import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function applyTheme(t) {
  document.documentElement.dataset.theme = t;
  localStorage.setItem("hc_theme", t);
}

export function ThemeToggle() {
  const [theme, setTheme] = useState(() => localStorage.getItem("hc_theme") || "journal");
  useEffect(() => { applyTheme(theme); }, [theme]);
  const night = theme === "night";
  return (
    <button onClick={() => setTheme(night ? "journal" : "night")} data-testid="theme-toggle" aria-label={night ? "Switch to Field Journal (light)" : "Switch to Night Garden (dark)"}
      title={night ? "Field Journal" : "Night Garden"}
      className="w-9 h-9 grid place-items-center rounded-full text-stone-600 hover:bg-stone-900 hover:text-white transition-colors">
      {night ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
